export const DOC_TYPE_OPTIONS = [
  { value: "unsigned", label: "Bản chưa ký" },
  { value: "signed", label: "Bản đã ký" },
  { value: "appendix", label: "Phụ lục" },
  { value: "other", label: "Khác" },
];

export const DOC_TYPE_LABELS = Object.fromEntries(
  DOC_TYPE_OPTIONS.map((o) => [o.value, o.label])
);

export const extractFileName = (urlOrName) => {
  if (!urlOrName) return "Chứng từ đính kèm";
  if (!String(urlOrName).includes("/")) return urlOrName;
  try {
    const pathname = new URL(urlOrName).pathname;
    const name = decodeURIComponent(pathname.split("/").pop() || "");
    return name || "Chứng từ đính kèm";
  } catch {
    const parts = String(urlOrName).split("/");
    return decodeURIComponent(parts[parts.length - 1] || "Chứng từ đính kèm");
  }
};

export const formatFileSize = (bytes) => {
  if (!bytes) return "—";
  if (bytes >= 1_000_000) return `${(bytes / 1_000_000).toFixed(1)} MB`;
  if (bytes >= 1_000) return `${(bytes / 1_000).toFixed(1)} KB`;
  return `${bytes} B`;
};
